export default __webpack_public_path__ + "static/media/change.78f99853.png";